import Vue from 'vue';
import FavoriteButton from './FavoriteButton.vue';

// Initialize the app when document is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('Players script loaded');
  
  // Check if we have valid Firebase config from WordPress
  if (!window.firebaseConfig || !window.firebaseConfig.apiKey || window.firebaseConfig.apiKey === 'placeholder') {
    console.error('Firebase configuration is missing or invalid');
    return;
  }
  
  // Create Vue instance for each favorite button on the page
  const favoriteBtnContainers = document.querySelectorAll('.favorite-button-container');
  
  console.log('Found favorite button containers:', favoriteBtnContainers.length);
  
  // First, show all Vue containers and hide the default buttons
  favoriteBtnContainers.forEach(container => {
    container.style.display = 'block';
    
    // Hide the fallback button (the next sibling that's a button)
    const fallbackBtn = container.nextElementSibling;
    if (fallbackBtn && fallbackBtn.classList.contains('favorite-button')) {
      fallbackBtn.style.display = 'none';
    }
  });
  
  // Then initialize Vue on each container
  favoriteBtnContainers.forEach((container, index) => {
    console.log(`Mounting Vue instance to container ${index}:`, container);
    
    new Vue({
      el: container,
      components: {
        FavoriteButton
      }
    });
  });
}); 